import React from 'react';
import { RadioButton } from '@progress/kendo-react-inputs';
import { useTranslation } from 'react-i18next';

const DateTimeTypeField = ({ value, onChange, disabled }) => {
    const { t } = useTranslation([
        "attribute/date_time_field",
    ], {
        useSuspense: false
    })

    return (
        <div>
            <span className="me-4">
                <RadioButton
                    checked={value === "date"}
                    value="date"
                    label={t("date")}
                    onChange={onChange}
                    disabled={disabled} />
            </span>
            <span className="me-4">
                <RadioButton
                    checked={value === "datetime"}
                    value="datetime"
                    label={t("date_time")}
                    onChange={onChange}
                    disabled={disabled} />
            </span>
            <span className="me-2">
                <RadioButton
                    checked={value === "time"}
                    value="time"
                    label={t("time")}
                    onChange={onChange}
                    disabled={disabled} />
            </span>
        </div>
    );
};

export default DateTimeTypeField;
